import { useMemo } from "react";
import { usePeopleByCompany } from "@/entities/people/hooks";

interface UseCompanyHasPeopleProps {
  companyId: string;
}

interface UseCompanyHasPeopleReturn {
  hasPeople: boolean;
  isLoading: boolean;
  isError: boolean;
}

export const useCompanyHasPeople = ({
  companyId
}: UseCompanyHasPeopleProps): UseCompanyHasPeopleReturn => {
  const {
    data: peopleByCompanyData,
    isLoading,
    isError
  } = usePeopleByCompany(companyId);

  const hasPeople = useMemo(() => {
    if (!peopleByCompanyData?.ids) return false;
    return peopleByCompanyData.ids.length > 0;
  }, [peopleByCompanyData?.ids]);

  return {
    hasPeople,
    isLoading,
    isError
  };
};
